// extracted by mini-css-extract-plugin
export default {"top_banner":"Mytransactions_top_banner__BnB9z","heading":"Mytransactions_heading__6n+tW","cardstyle":"Mytransactions_cardstyle__unUYu","btn":"Mytransactions_btn__aoteS"};